import { Howl } from 'howler';
import { staticAssets } from 'js/constants/Paths';

const audioManifests = import.meta.glob('../../../assets/64/*.json', {
  eager: true,
  import: 'default',
});

const audioFiles = import.meta.glob('../../../assets/64/*.mp3', {
  eager: true,
  import: 'default',
  query: '?url',
});

const emptyAudioManifest = { spritemap: {} };

const getAudioManifest = (filename) => {
  return audioManifests[`../../../assets/64/${filename}`] || emptyAudioManifest;
};

const getAudioFile = (filename) => {
  if (JW_WATCH) {
    return staticAssets(`assets/64/${filename}`);
  }

  return audioFiles[`../../../assets/64/${filename}`] || null;
};

const hasSprites = (sprite) => {
  return Object.keys(sprite).length > 0;
};

const createSpriteMap = (audioData) => {
  return Object.keys(audioData.spritemap || {}).reduce((acc, key) => {
    if (key !== 'silence') {
      const { start, end } = audioData.spritemap[key];
      acc[key] = [start * 1000, end * 1000 - start * 1000];
    }
    return acc;
  }, {});
};

const sfxData = getAudioManifest('sfx.json');
const musicData = getAudioManifest('music.json');
const spriteSFX = createSpriteMap(sfxData);
const spriteMusic = createSpriteMap(musicData);

export const createHowlerIntroVO = (howlerData, handleVoEnd) => {
  const { src, sprite } = howlerData;
  return new Howl({
    preload: true,
    src,
    autoplay: false,
    loop: false,
    volume: 0.5,
    pool: 1,
    sprite,
    onend: function (id) {
      handleVoEnd(id);
    },
  });
};

const getSrc = (filename) => {
  const url = getAudioFile(filename);
  return url ? [url] : [];
};

export const createHowlerIntroMusic = () => {
  const src = getSrc('music.mp3');
  if (!src.length || !hasSprites(spriteMusic)) return null;

  return new Howl({
    preload: true,
    src,
    autoplay: false,
    loop: true,
    volume: 0.4,
    sprite: spriteMusic,
  });
};

export const createHowlerIntroSFX = () => {
  const src = getSrc('sfx.mp3');
  if (!src.length || !hasSprites(spriteSFX)) return null;

  return new Howl({
    preload: true,
    src,
    autoplay: false,
    loop: false,
    volume: 0.3,
    sprite: spriteSFX,
  });
};

const createHowlerSFX = () => {
  const src = getSrc('sfx.mp3');
  if (!src.length || !hasSprites(spriteSFX)) return null;

  return new Howl({
    preload: true,
    src,
    autoplay: false,
    loop: false,
    volume: 0.5,
    pool: 3,
    sprite: spriteSFX,
  });
};

let howlerSFX = null;
let howlerMusic = null;
export const getHowlerSFX = () => {
  if (!howlerSFX) {
    howlerSFX = createHowlerSFX();
  }
  return howlerSFX;
};

export const getHowlerMusic = () => {
  if (!howlerMusic) {
    howlerMusic = createHowlerIntroMusic();
  }
  return howlerMusic;
};

export const howlerSFXPlayer = {
  play: function (key, vol = 0.5) {
    if (key) {
      const h = getHowlerSFX();
      if (!h) return;
      const id = h.play(key);
      h.volume(vol, id);
    }
  },
  stop: function (key) {
    if (key) {
      const h = getHowlerSFX();
      if (!h) return;
      h.stop(key);
    }
  },
};

export const howlerMusicPlayer = {
  play: function (key, vol = 0) {
    if (key) {
      const h = getHowlerMusic();
      if (!h) return;
      const id = h.play(key);
      h.volume(vol, id);
    }
  },
  stopMusic: function (key) {
    if (key) {
      const h = getHowlerMusic();
      if (!h) return;
      h.stop(key);
    }
  },
};
